'use client';

import { Button } from '@/components/ui/button';
import { getEnvironmentConfig, isNonProdEnvironment } from '@/utils/common/environment';
import Image from 'next/image';
import { useRouter } from 'next/navigation';
import { useCallback, useState } from 'react';
import Buttonicon from '../../public/images/login_icon.svg';
import Logoimg from '../../public/images/MG_Logo_NextStar_Blue.png';
export default function Login() {
  const router = useRouter();
  const [isLoading, setIsLoading] = useState(false);
  const {
    name
  } = getEnvironmentConfig();
  // handle login
  const handleLogin = useCallback(() => {
    if (isLoading) {
      return;
    }
    setIsLoading(true);
    const authUrl = process.env.NEXT_PUBLIC_BACKEND_AUTH_URL;
    if (authUrl) {
      router.push(authUrl);
    } else {
      setIsLoading(false);
      alert('Authentication URL is not defined.');
    }
  }, []);
  return <div className="flex h-full w-full items-center justify-center" data-sentry-component="Login" data-sentry-source-file="Login.tsx">
      <div className="mx-4 w-[100%] rounded-xl bg-white px-5 py-7 backdrop-blur-xl backdrop-filter sm:w-[350px] md:mx-0 md:px-6 md:py-10 2xl:w-[450px] 2xl:px-10 2xl:py-14">
        <Image src={Logoimg} width={70} height={50} alt="TRS" className="m-auto" data-sentry-element="Image" data-sentry-source-file="Login.tsx" />
        {isLoading ? <Image src="/images/loader.gif" width={150} height={35} alt="TRS" className="m-auto mt-3 md:mt-4 2xl:mt-8" /> : <Button variant="login" onClick={handleLogin} className="mt-4 w-full md:mt-6 2xl:mt-8" disabled={isLoading}>
            <Image src={Buttonicon} width={25} height={25} alt="" className="" />
            {isNonProdEnvironment() ? `Login to ${name.toUpperCase()}` : 'Login'}
          </Button>}
      </div>
    </div>;
}